import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ReportTemplateGetById, ReportTemplateGetByIdResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<ReportTemplateGetByIdResponse, ReportTemplateGetByIdResponse>) => {
    return response?.data;
}
const getError = (response?: SWRResponse<ReportTemplateGetByIdResponse, ReportTemplateGetByIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => ({});

const useReportTemplateById = (templateId?: number, configuration?: SWRConfiguration<ReportTemplateGetByIdResponse, ReportTemplateGetByIdResponse>) => {
    const request = useMemo(() => {
        if(!templateId) return undefined;
        return () => {
            return new ReportTemplateGetById({
                templateId: templateId
            });
        };
    }, [templateId])

    return useGet(request, { getData, getError }, configuration);
}

export default useReportTemplateById;